export default "__VITE_ASSET__TPrGN8ud__"